/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useEmpresa from "../../../hooks/useEmpresa";
import { EMPRESA, PROGRAMA } from "../../../utils/Constant";
import {
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
  DEFAULT_TITULO,
} from "../utils/AutorizacionConstant";

/**
 * Hook personalizado para validar el tipo de programa basado en el parámetro de consulta del querystring en la URL
 * @returns {Object} Estado de validación del programa y funciones auxiliares
 */
const useValidateProgram = () => {
  // Obtener todas las dependencias primero
  const empresa = useEmpresa();
  const location = useLocation();
  const userData = useSelector((state) => state.auth.authUserData);
  const { prestador, configuracionPaperFree } = userData;

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  // Inicializar el estado con valores calculados inmediatamente
  const initialState = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const programParam = params.get("program");

    // Valores por defecto
    const defaultState = {
      title: DEFAULT_TITULO,
      tipoServicio: "",
      isPaperFree: configuracionPaperFree?.esPaperFree || false,
      isCronicoComplejo: false,
      isPromocionPrevencion: false,
      isCeroTramite: false,
    };

    // Si no hay parámetro de programa, devolver estado por defecto
    if (!programParam) {
      return defaultState;
    }

    // Estado base con las propiedades calculadas
    const baseState = {
      ...defaultState,
      isCronicoComplejo:
        programParam === PROGRAMA.CRONICO_COMPLEJO.CODIGO && isPrimera,
      isPromocionPrevencion:
        programParam === PROGRAMA.PROMOCION_PREVENCION.CODIGO &&
        prestador.pyp &&
        isPrimera,
      isCeroTramite:
        programParam === PROGRAMA.CERO_TRAMITE.CODIGO &&
        prestador.esCeroTramite &&
        isPrimera,
    };

    // Aplicar configuraciones específicas según el tipo de programa
    switch (programParam.toLowerCase()) {
      case "cc":
        return {
          ...baseState,
          title: `Agregar Reclamación ${PROGRAMA.CRONICO_COMPLEJO.DESCRIPCION}`,
          tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO,
        };
      case "pyp":
        return {
          ...baseState,
          title: `Agregar Reclamación ${PROGRAMA.PROMOCION_PREVENCION.DESCRIPCION}`,
          tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.PROMOCION_PREVENCION,
        };
      case "ct":
        return {
          ...baseState,
          title: `Agregar Reclamación ${PROGRAMA.CERO_TRAMITE.DESCRIPCION}`,
          tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.CERO_TRAMITE,
        };
      default:
        return defaultState;
    }
  }, [location.search, isPrimera, prestador, configuracionPaperFree]);

  // Usar el estado calculado como valor inicial
  const [programType] = useState(initialState);

 
  return programType;
};

export default useValidateProgram;
